import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';

interface RadarChartProps {
  data: {
    empathy: number;
    growth: number;
    adaptability: number;
    purpose: number;
  };
}

const EGAPRadarChart: React.FC<RadarChartProps> = ({ data }) => {
  const chartData = [
    {
      trait: 'Empathy',
      score: data.empathy,
      fullMark: 100,
    },
    {
      trait: 'Growth',
      score: data.growth,
      fullMark: 100,
    },
    {
      trait: 'Adaptability', 
      score: data.adaptability,
      fullMark: 100,
    },
    {
      trait: 'Purpose',
      score: data.purpose,
      fullMark: 100,
    },
  ];

  return (
    <ResponsiveContainer width="100%" height={320}>
      <RadarChart data={chartData} margin={{ top: 40, right: 80, bottom: 40, left: 80 }}>
        <PolarGrid stroke="#e5e7eb" />
        <PolarAngleAxis 
          tick={{ fontSize: 12, fill: '#6b7280' }}
          className="text-sm font-medium"
        />
        <PolarRadiusAxis 
          tick={{ fontSize: 10, fill: '#9ca3af' }}
          domain={[0, 100]}
          angle={90}
        />
        <Radar
          name="EGAP Score"
          dataKey="score"
          stroke="#3b82f6"
          fill="#3b82f6"
          fillOpacity={0.3}
          strokeWidth={2}
          dot={{ fill: '#3b82f6', strokeWidth: 2, r: 4 }}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default EGAPRadarChart;